export class BadRequest extends Error {
  constructor(message = 'bad request') {
    super(message)

    this.name = 'BadRequest'
  }
}
